import React, { useContext, useEffect, useRef } from "react";
import { ContextEngine } from "../engine/ContextEngine";
import { ModalRegistry } from "../modals";

export default function ModalRenderer() {
  const { context, updateContext } = useContext(ContextEngine);
  const modal = context.view?.modal;
  const modalRef = useRef(null);  // Reference for outside click detection

  const closeModal = () => updateContext("view.modal", null);

  // Detect click outside modal to close it
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        closeModal();  // Close modal on outside click
      }
    };

    if (modal) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [modal]);

  // If no modal, return null (don't render modal)
  if (!modal) return null;

  // Check if modal component exists in registry
  const ModalComponent = ModalRegistry[modal.type];
  if (!ModalComponent) {
    console.warn(`Modal type "${modal.type}" not found in ModalRegistry`);
    return null;  // If modal type not found, return null
  }

  return (
    <div ref={modalRef}>
      <ModalComponent {...modal.props} closeModal={closeModal} />
    </div>
  );
}
